import { gql } from "apollo-boost"

export const CREATE_IMPLEMENTER_ACCOUNT = gql`
  mutation CreateImplementerAccount($data: CreateAccount!, $implementerId: ID!) {
    CreateImplementerAccount(implementerId: $implementerId, data: $data) {
      id
      uid
      displayName
      implementer {
        id
        name
      }
    }
  }
`
